import { Injectable } from '@angular/core';
import { Instance } from 'tippy.js';

@Injectable({ providedIn: 'root' })
export class PopoverService {
  private instances = new Map<string, Instance>();

  public addInstance(id: string, instance: Instance) {
    this.instances.set(id, instance);
  }

  public removeInstance(id: string) {
    this.instances.delete(id);
  }

  public show(id: string) {
    const instance = this.instances.get(id);

    if (instance) {
      instance.show();
    } else {
      throw new Error(
        `Could not find popover with id: '${id}' - was an id assigned in the template?`,
      );
    }
  }

  public hide(id: string) {
    // if the instance is not found, it is likely the popover no longer exists ie: navigated away from page
    // so don't throw an error
    this.instances.get(id)?.hide();
  }

  public display(id: string, display: boolean) {
    if (display) {
      this.show(id);
    } else {
      this.hide(id);
    }
  }
}
